module.exports = __webpack_public_path__ + "img/home-hero-bg-lg.d52fb85f.png";